import React, { Component } from "react"
import { Accordion, Card, Spinner, Table } from "react-bootstrap"
import moment from "moment"
import { getVault77ErrorMessage } from "src/components/vault77/core/apiError"
import { getAuditLog } from "src/components/vault77/dataAccessAudit/api/dataAccessAudit.api"
import type { DataAccessAudit } from "src/components/vault77/dataAccessAudit/types"
import "./UserHistory.css"

interface UserHistoryProps {
    userId: number
}

type UserHistoryState = {
    records: DataAccessAudit[]
    loading: boolean
    error: string | null
}

class UserHistory extends Component<UserHistoryProps, UserHistoryState> {

    state: UserHistoryState = {
        records: [],
        loading: true,
        error: null,
    }

    componentDidMount() {
        this.load()
    }

    load = async () => {
        this.setState({ loading: true, error: null })
        try {
            const records = await getAuditLog({ employeeId: this.props.userId })
            records.sort((a, b) => new Date(b.AccessDate).getTime() - new Date(a.AccessDate).getTime())
            this.setState({ records, loading: false })
        } catch (err) {
            this.setState({ loading: false, error: getVault77ErrorMessage(err, "Unable to load the audit log.") })
        }
    }

    renderBody = () => {
        const { records, loading, error } = this.state
        if (loading) {
            return <div className="uac-history-loading"><Spinner animation="border" variant="secondary" /></div>
        }
        if (error) {
            return <p className="uac-history-error">{error}</p>
        }
        if (records.length === 0) {
            return <p className="uac-history-empty">No audit records yet.</p>
        }
        return (
            <Table size="sm" hover responsive className="uac-history-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>User</th>
                        <th>Action</th>
                        <th>Table</th>
                        <th>Column</th>
                        <th>Result</th>
                    </tr>
                </thead>
                <tbody>
                    {records.map((r) => (
                        <tr key={r.AuditId}>
                            {/* AccessDate is stored UTC but serialized without a 'Z' (it round-trips
                                through SQL datetime2, losing the Kind). Parse as UTC, then render in
                                the viewer's local time. */}
                            <td>{moment.utc(r.AccessDate).local().format("MMM D, YYYY h:mm A")}</td>
                            <td>{r.WindowsIdentity || r.UserId}</td>
                            <td>{r.Action}</td>
                            <td>{r.TableName || "—"}</td>
                            <td>{r.ColumnName || "—"}</td>
                            <td>{r.Success ? "Success" : (r.FailureReason || "Failed")}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    }

    render() {
        return (
            <div className="UserHistory">
                <Accordion defaultActiveKey="1" id="user-admin-accordion">
                    <Card id="user-admin-card">
                        <Accordion.Toggle as={Card.Header} eventKey="0">
                            <div id="user-admin-card-title"><p>History</p></div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <div id="uac-history-info">
                                {this.renderBody()}
                            </div>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </div>
        )
    }
}

export default UserHistory
